import PartnerList from './partner.vue'
export default PartnerList
